import { Component, OnInit, inject } from '@angular/core';
import { MatDialogRef, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-modal-task-create',
    templateUrl: './modal-task-create.component.html',
    styleUrls: ['./modal-task-create.component.scss'],
    imports: [CdkScrollable, MatDialogContent, FormsModule, ReactiveFormsModule, MatSelect, MatOption, MatDialogActions, MatButton, MatDialogClose]
})
export class ModalTaskCreateComponent implements OnInit {
    dialogRef = inject<MatDialogRef<ModalTaskCreateComponent>>(MatDialogRef);


    public formTask = new FormGroup({
        titre: new FormControl<string>('', [Validators.required]),
        message: new FormControl<string>('', [Validators.required]),
        weight: new FormControl<number>(80, [Validators.required])
    });

      constructor() { }

      ngOnInit(): void {
      }

      submit() {

      }
}
